<template>
  <div>
    <el-form ref="formRef" :model="setsForm" label-width="140px">
      <el-form-item label="平台：">
        <el-radio-group v-model="platformType" @change="platformTypeChange">
          <el-radio :label="1" size="large">安卓</el-radio>
          <el-radio :label="4" size="large">鸿蒙</el-radio>
          <el-radio :label="2" size="large">苹果</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="版本：">
        <el-radio-group v-model="versionState" @change="versionStateChange">
          <el-radio :label="1" size="large">旧版VIP</el-radio>
          <el-radio :label="2" size="large">4.2版本及以上</el-radio>
<!--          <el-radio :label="3" size="large">4.5版本及以上</el-radio>-->
        </el-radio-group>
      </el-form-item>
      <el-form-item label="支付方式：" v-if="platformType != 2 && versionState > 1">
        <el-radio-group v-model="payMode" @change="payModeChange">
          <el-radio :label="1" size="large">支付宝</el-radio>
          <el-radio :label="2" size="large">微信</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="类型：">
        <el-radio-group v-model="payType" :disabled="payMode == 2" @change="payTypeChange">
          <el-radio :label="1" size="large">普通</el-radio>
          <el-radio :label="2" size="large">自动续费</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="展示包类型：" v-if="payMode == 1">
        <div>
          <el-radio-group v-model="isSpecialPackage">
            <el-radio :label="0" size="large">全部包</el-radio>
            <el-radio :label="1" size="large">特定包</el-radio>
            <el-radio :label="2" size="large">非特定包</el-radio>
          </el-radio-group>
          <div v-if="isSpecialPackage == 1" style="font-size: 12px; color: #aaaaaa; line-height: 1.5">
            <p v-for="(item, index) in wechatPayPackageSpecialHand" :key="index" >{{index+1}}、{{item}}</p>
          </div>
        </div>

      </el-form-item>

      <el-form-item label="渠道：" v-if="platformType == 2">
        <el-input v-model="setsForm.channel" placeholder="请输入渠道名称" style="width:25em;"/>
      </el-form-item>
      <el-form-item label="product_id：" v-if="platformType == 2">
        <el-input v-model="setsForm.productId" placeholder="请输入产品ID" style="width:25em;"/>
      </el-form-item>
      <el-form-item label="商品名称：">
        <el-input v-model="setsForm.name" placeholder="请输入商品名称" style="width:25em;"/>
      </el-form-item>
      <el-form-item label="说明：">
        <el-input v-model="setsForm.oldPrice" placeholder="请输入说明" style="width:25em;">
<!--          <template #suffix>-->
<!--            <el-icon class="el-input__icon"><i class="fa fa-jpy" aria-hidden="true"></i></el-icon>-->
<!--          </template>-->
        </el-input>
      </el-form-item>
      <el-form-item label="标签内容：">
        <el-input v-model="setsForm.tagContent" placeholder="请输入标签内容" style="width:25em;"/>
      </el-form-item>
      <el-form-item label="支付价格：">
        <el-input v-model="setsForm.price" placeholder="请输入价格" style="width:25em;">
          <template #suffix>
            <el-icon class="el-input__icon"><i class="fa fa-jpy" aria-hidden="true"></i></el-icon>
          </template>
        </el-input>
      </el-form-item>
      <el-form-item label="账单名称：">
        <el-input v-model="setsForm.billName" placeholder="请输入账单名称" style="width:25em;" />
      </el-form-item>
      <el-form-item label="免费试用天数：" v-if="payType == 2">
        <el-input v-model="setsForm.freeDay" placeholder="请输入免费试用天数" style="width:25em;" />
        <p style="color: red; font-size: 13px">*0元体验赠送的会员天数</p>
      </el-form-item>
      <el-form-item label="性别：">
        <el-radio-group v-model="sex">
          <el-radio :label="0" size="large">不限</el-radio>
          <el-radio :label="1" size="large">男</el-radio>
          <el-radio :label="2" size="large">女</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="排序：">
        <el-input v-model="setsForm.orderNum" placeholder="数字越大越靠前" style="width:25em;"/>
      </el-form-item>
      <el-form-item label="会员类型：">
        <el-radio-group v-model="type">
          <el-radio :label="1" size="large">普通会员</el-radio>
          <el-radio :label="2" size="large">终身会员</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="vip时长：" v-if="type == 1">
        <el-input v-model="setsForm.expireTime" placeholder="请输入vip时长" style="width:25em;" :disabled="(setsForm.state == 1 || setsForm.state == 2) && payType == 2">
          <template #suffix>
            <span>天</span>
          </template>
        </el-input>
      </el-form-item>
      <el-form-item label="新人状态：">
        <el-radio-group v-model="newuserShow">
          <el-radio :label="0" size="large">全部</el-radio>
          <el-radio :label="1" size="large">新用户</el-radio>
          <el-radio :label="2" size="large">非新用户</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="VIP状态：">
        <el-radio-group v-model="vipShow">
          <el-radio :label="0" size="large">全部</el-radio>
          <el-radio :label="1" size="large">已开通过VIP会员</el-radio>
          <el-radio :label="2" size="large">未开通过VIP会员</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="可见用户类型：">
        <el-radio-group v-model="isFocusUser">
          <el-radio :label="0" size="large">全部</el-radio>
          <el-radio :label="2" size="large">关注用户</el-radio>
          <el-radio :label="1" size="large">未关注用户</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="submit">确定</el-button>
    </div>
  </div>

</template>

<script>
import {getFormData, postFormData} from "@/api/api"
import {addOrUpdateVipList, getCommonSysParam} from "@/api/url";

export default {
  name: "SetsDialog",
  props: {
    value: Object
  },
  data() {
    return {
      setsForm: this.value.setsForm,
      idx: this.value.ids,

      platformType: this.value.ids > -1? this.value.setsForm.platformType: 1,
      payType: this.value.ids > -1? this.value.setsForm.payType: 1,
      newuserShow: this.value.ids > -1? this.value.setsForm.newuserShow: 0,
      vipShow: this.value.ids > -1? this.value.setsForm.vipShow: 0,
      isFocusUser: this.value.ids > -1? this.value.setsForm.isFocusUser: 0,
      // isOld: this.value.ids > -1? this.value.setsForm.isOld: 0,
      versionState: this.value.ids > -1? this.value.setsForm.versionState: 1,
      payMode: this.value.setsForm.payMode?this.value.setsForm.payMode:0,
      isSpecialPackage: this.value.setsForm.isSpecialPackage?this.value.setsForm.isSpecialPackage:0,

      sex: this.value.ids > -1? this.value.setsForm.sex: 0,
      sexArray: [
        {label:'不限', value:0},
        {label:'男', value:1},
        {label:'女', value:2},
      ],

      type: this.value.ids > -1? this.value.setsForm.type: 1,
      typeArray: [
        {label:'普通会员', value:1},
        {label:'终身会员', value:2},
      ],

      wechatPayPackageSpecialHand: []

    }
  },
  methods: {

    payTypeChange(val) {
      // if(val == 2) {
      //   this.isSpecialPackage = 0
      // }
    },

    platformTypeChange(val) {
      if(val == 2) {
        this.payMode = 0
      }
    },

    versionStateChange(val) {
      if(val == 1) {
        this.payMode = 0
      }
    },

    payModeChange(val) {
      if(val == 2) {
        this.payType = 1
        this.isSpecialPackage = 0
      }
    },

    cancel() {
      this.$emit("close");
    },
    submit() {

      if(this.platformType != 2 && this.versionState > 1 && !this.payMode) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请选择支付方式',
          type: 'warning'
        });
        return false
      }

      if(this.platformType == 2 && !this.setsForm.channel) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '渠道名称不能为空',
          type: 'warning'
        });
        return false
      }
      if(this.platformType == 2 && !this.setsForm.productId) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '产品ID不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.setsForm.name) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '商品名称不能为空',
          type: 'warning'
        });
        return false
      }
      // if(!this.setsForm.oldPrice) {
      //   this.$message({
      //     showClose: true,
      //     duration: 2000,
      //     message: '原价不能为空',
      //     type: 'warning'
      //   });
      //   return false
      // }
      if(!this.setsForm.price) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: (this.platformType == 1 || this.platformType == 4?'支付价格':'展示价格') + '不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.setsForm.billName) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '账单名称不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.setsForm.orderNum && this.setsForm.orderNum != 0) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '排序不能为空',
          type: 'warning'
        });
        return false
      }
      if(this.type == 1 && !this.setsForm.expireTime) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: 'vip时长不能为空',
          type: 'warning'
        });
        return false
      }
      let param = {}
      param['id'] = this.idx == -1?0: this.setsForm.id;
      param['channel'] = this.platformType == 2?this.setsForm.channel:'app';
      param['productId'] = this.platformType == 2?this.setsForm.productId:0;
      param['sex'] = this.sex;
      param['type'] = this.type;
      param['name'] = this.setsForm.name;
      param['billName'] = this.setsForm.billName;
      param['oldPrice'] = this.setsForm.oldPrice;
      param['tagContent'] = this.setsForm.tagContent;
      param['price'] = this.setsForm.price;
      param['expireTime'] = this.type == 1?this.setsForm.expireTime*(24*3600):0;
      param['freeDay'] = this.setsForm.freeDay && this.payType == 2?this.setsForm.freeDay:0;
      param['orderNum'] = this.setsForm.orderNum;
      param['newuserShow'] = this.newuserShow;
      param['vipShow'] = this.vipShow;
      param['platformType'] = this.platformType;
      param['payType'] = this.payType;
      param['versionState'] = this.versionState;
      param['payMode'] = this.payMode;
      param['isSpecialPackage'] = this.isSpecialPackage;
      param['isFocusUser'] = this.isFocusUser;
      postFormData(addOrUpdateVipList, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', param)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    },

    getCommon() {
      getFormData(getCommonSysParam).then(data => {
        let {msg, code } = data;
        if(code == 200) {
          this.wechatPayPackageSpecialHand = data.data.wechatPayPackageSpecialHand.split(',')
        }
      })
    },


  },
  mounted() {
    this.getCommon()
    if(this.idx == -1) {
      this.payMode = 1
    }
  }
}
</script>

<style scoped>

</style>
